import {
	ERRORS_CLEAR,
	TICKET_LOADING_TRUE,
	TICKET_LOADING_FALSE,
	TICKET_CREATE,
	TICKET_CREATE_ERROR,
	ALL_TICKETS_LOADING,
	ALL_TICKETS_GET,
	ALL_TICKETS_ERROR,
	TICKET_REASONS_LOADING,
	TICKET_REASONS_GET,
	TICKET_REASONS_ERROR,
	TICKET_SETTINGS_LOADING,
	TICKET_SETTINGS_GET,
	TICKET_SETTINGS_ERROR,
	MY_TICKETS_LOADING,
	MY_TICKETS_GET,
	MY_TICKETS_ERROR,
	RESOLVED_TICKETS_LOADING,
	RESOLVED_TICKETS_GET,
	RESOLVED_TICKETS_ERROR,
	TICKET_EXISTS_LOADING,
	TICKET_EXISTS_GET,
	TICKET_EXISTS_ERROR,
	TICKET_HISTORY_LOADING,
	TICKET_HISTORY_GET,
	TICKET_HISTORY_ERROR
} from '../actions/types';

const initialState = {
	ticket_loading: false,
	ticket_create_success: false,
	all_tickets_loading: false,
	all_tickets: { count: 0, tickets: [] },
	ticket_reasons_loading: false,
	ticket_reasons: { count: 0, reasons: [] },
	ticket_settings_loading: false,
	// Effective config from /settings/mine (flat object), null until fetched.
	ticket_settings: null,
	my_tickets_loading: false,
	my_tickets: { count: 0, tickets: [] },
	resolved_tickets_loading: false,
	resolved_tickets: { count: 0, tickets: [] },
	ticket_exists_loading: false,
	// { target, targetId, exists, code, status, errored } — null until fetched.
	// Carries the answered target so consumers can reject a leftover answer from
	// a previously visited object.
	ticket_exists: null,
	ticket_history_loading: false,
	// { ticketId, count, history, errored } — null until fetched. Carries the
	// ticket it answers for so a consumer can reject the previous ticket's log.
	ticket_history: null,
	error: { isError: false, type: '', msg: '', fields: {}, status: undefined }
}

export default function ticketReducer (state = initialState, action){
	switch (action.type){
		case ERRORS_CLEAR:
			return {
				...state,
				error: { isError: false, type: '', msg: '', fields: {}, status: undefined }
			}
		case TICKET_LOADING_TRUE:
			return {
				...state,
				ticket_loading: true
			}
		case TICKET_LOADING_FALSE:
			return {
				...state,
				ticket_loading: false
			}
		case TICKET_CREATE:
			return {
				...state,
				ticket_create_success: action.payload
			}
		case ALL_TICKETS_LOADING:
			return {
				...state,
				all_tickets_loading: action.payload
			}
		case ALL_TICKETS_GET:
			return {
				...state,
				all_tickets: {
					count: action.payload.count,
					tickets: action.payload.tickets
				}
			}
		case TICKET_REASONS_LOADING:
			return {
				...state,
				ticket_reasons_loading: action.payload
			}
		case TICKET_REASONS_GET:
			return {
				...state,
				ticket_reasons: {
					count: action.payload.count,
					reasons: action.payload.reasons
				}
			}
		case TICKET_SETTINGS_LOADING:
			return {
				...state,
				ticket_settings_loading: action.payload
			}
		case TICKET_SETTINGS_GET:
			return {
				...state,
				ticket_settings: action.payload
			}
		case MY_TICKETS_LOADING:
			return {
				...state,
				my_tickets_loading: action.payload
			}
		case MY_TICKETS_GET:
			return {
				...state,
				my_tickets: {
					count: action.payload.count,
					tickets: action.payload.tickets
				}
			}
		case RESOLVED_TICKETS_LOADING:
			return {
				...state,
				resolved_tickets_loading: action.payload
			}
		case RESOLVED_TICKETS_GET:
			return {
				...state,
				resolved_tickets: {
					count: action.payload.count,
					tickets: action.payload.tickets
				}
			}
		case TICKET_EXISTS_LOADING:
			return {
				...state,
				ticket_exists_loading: action.payload
			}
		case TICKET_EXISTS_GET:
			return {
				...state,
				ticket_exists: { ...action.payload, errored: false }
			}
		case TICKET_EXISTS_ERROR:
			// Keep the target so the consumer knows the answer for THIS object is
			// unusable, instead of silently reading the previous object's answer.
			return {
				...state,
				ticket_exists: {
					target: action.payload.target,
					targetId: action.payload.targetId,
					exists: null,
					code: null,
					status: null,
					errored: true
				},
				error: {
					isError: true,
					type: action.payload.type,
					msg: action.payload.msg,
					fields: {},
					status: undefined
				}
			}
		case TICKET_HISTORY_LOADING:
			return {
				...state,
				ticket_history_loading: action.payload
			}
		case TICKET_HISTORY_GET:
			return {
				...state,
				ticket_history: { ...action.payload, errored: false }
			}
		case TICKET_HISTORY_ERROR:
			// Keep the ticket id so the consumer knows the answer for THIS ticket is
			// unusable instead of silently reading the previous one's. The note is an
			// extra, so unlike the other lookups this never touches the shared
			// `error` slice: a failure here must stay invisible.
			return {
				...state,
				ticket_history: {
					ticketId: action.payload.ticketId,
					count: 0,
					history: [],
					errored: true
				}
			}
		case TICKET_CREATE_ERROR:
		case ALL_TICKETS_ERROR:
		case TICKET_REASONS_ERROR:
		case TICKET_SETTINGS_ERROR:
		case MY_TICKETS_ERROR:
		case RESOLVED_TICKETS_ERROR:
			return {
				...state,
				error: {
					isError: true,
					type: action.payload.type,
					msg: action.payload.msg,
					fields: action.payload.fields || {},
					status: action.payload.status
				}
			}
		default:
			return state;
	}
}
